import { locations } from './locations';

export const viewers = {
  locations,
};
